export function audioNotificar() {
    const audio = new Audio('../../assets/audio/audioNotificacion.mp3')
    audio.play()
}